import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { Textarea } from '../ui/Textarea';
import { MascotPanel } from '../ui/MascotPanel';
export function Step9Type() {
  const {
    data,
    updateData
  } = useIntake();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-576">
      <MascotPanel message="Laten we het technisch maken. Wat voor type website bouwen we en welke functionaliteiten zijn onmisbaar?" detailedInfo="Dit formulier is geen indicatie! Hier maakt u echte keuzes voor uw project. De opties die u hier kiest bepalen welke pagina's u in de volgende stap kunt selecteren." data-id="element-577" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-578">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-579">Type Website</h2>

        <div data-id="element-580">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-581">
            Wat voor type website heeft u nodig?
          </label>
          <RadioGroup columns={1} value={data.websiteType} onChange={val => updateData({
          websiteType: val
        })} options={[{
          value: 'website',
          label: 'Website',
          description: "Meerdere pagina's en opties (geen verkoop van producten)"
        }, {
          value: 'webshop',
          label: 'Webshop',
          description: 'Verkoop van spullen met winkelwagen en afrekenen'
        }, {
          value: 'onepager',
          label: 'Onepager',
          description: 'Homepagina en verder niets (evt. 1 extra pagina of blogs)'
        }]} data-id="element-582" />
        </div>

        <AnimatePresence data-id="element-583">
          {data.websiteType === 'webshop' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 pt-6 border-t border-gray-100 overflow-hidden" data-id="element-584">
              <h3 className="font-semibold text-gray-900" data-id="element-585">Webshop Details</h3>
              <Textarea label="Hoe wilt u dat de producten erin worden gezet?" placeholder="Bijv. handmatig, via een import, koppeling met boekhouding..." value={data.productManagement} onChange={e => updateData({
            productManagement: e.target.value
          })} data-id="element-586" />
            </motion.div>}

          {(data.websiteType === 'website' || data.websiteType === 'webshop') && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 pt-6 border-t border-gray-100 overflow-hidden" data-id="element-587">
              <h3 className="font-semibold text-gray-900" data-id="element-588">
                Portaal & Gebruikers
              </h3>

              <div data-id="element-589">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-590">
                  Moet er een klantenportaal komen?
                </label>
                <RadioGroup columns={2} value={data.needsPortal} onChange={val => updateData({
              needsPortal: val
            })} options={[{
              value: 'yes',
              label: 'Ja, klanten moeten kunnen inloggen'
            }, {
              value: 'no',
              label: 'Nee, dat is niet nodig'
            }]} data-id="element-591" />
              </div>

              {data.needsPortal === 'yes' && <div className="space-y-6 mt-4" data-id="element-592">
                  <Textarea label="Wat moet het portaal onthouden/tonen aan de klant?" placeholder="Bijv. bestelgeschiedenis, facturen, afspraken..." value={data.portalDetails} onChange={e => updateData({
              portalDetails: e.target.value
            })} data-id="element-593" />
                  <Textarea label="Zijn er meerdere mensen met verschillende rollen?" placeholder="Bijv. beheerder, medewerker, klant..." value={data.userRoles} onChange={e => updateData({
              userRoles: e.target.value
            })} data-id="element-594" />
                </div>}
            </motion.div>}
        </AnimatePresence>

        <div className="bg-blue-50 rounded-xl p-6 border border-blue-100" data-id="element-595">
          <p className="text-sm text-blue-800" data-id="element-596">
            <strong data-id="element-597">Goed om te weten:</strong> Wij bouwen onze websites altijd
            in WordPress, gecombineerd met Elementor (en WooCommerce voor
            webshops). Dit zorgt voor een flexibel en gebruiksvriendelijk
            systeem.
          </p>
        </div>
      </div>
    </motion.div>;
}